export default __webpack_public_path__ + "static/media/shwralogi.2ef569fd.svg";